import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
  gap: 8px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-width: 738px;
  padding: 0px 20px;
  align-items: flex-start;

  gap: 20px;
  align-self: stretch;
`;

export const CardContainer = styled.div`
  display: flex;
  min-width: 480px !important;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1;
  box-sizing: border-box;
  height: 100%;

  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .service {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: 16px;
    align-self: stretch;
    flex-wrap: wrap;
  }

  .service-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: var(--alias-color-line-normal);
`;

export const TabContainer = styled.div`
  display: flex;
  padding: 0px 24px;
  align-items: flex-end;
  gap: 20px;
  align-self: stretch;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 0 12px;
  align-items: center;
  height: 40px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  border-bottom: ${(props) => (props.selected ? "2px solid var(--alias-color-primary-normal)" : "none")};
  box-sizing: border-box;
`;
